import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY } from "../../../api/queryKeys";
import { QueryAdminTeamSettingsResponse } from "../../../types";

export const getTeamSettingsData = () =>
  api
    .get<QueryAdminTeamSettingsResponse>(
      QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY
    )
    .then((res) => res.data);

export default function useGetTeamSettings() {
  return useQuery(
    [QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY],
    getTeamSettingsData
  );
}
